import React from 'react';
import '../styles.css';

const HeroSection: React.FC = () => {
  return (
    <section className='hero-section'>
      {/* Dot pattern background */}
      <div className='hero-dot-pattern' />

      {/* Animated yellow blur effects */}
      <div className='hero-blur-1' />
      <div className='hero-blur-2' />

      {/* Content */}
      <div className='hero-content'>
        <h1>Defense Collaborative Research Platform</h1>
        <p>
          The trusted platform for defense research,
          <br />
          education and collaboration.
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
